(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  const postYoutube = (iframe, payload) => {
    if (!iframe?.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify(payload), "*");
  };

  const youtubeSetMuted = (iframe, muted) => {
    if (!iframe?.contentWindow) return;
    if (muted) {
      postYoutube(iframe, { event: "command", func: "mute", args: "" });
      return;
    }
    // Same turn: unmute + full volume twice — YouTube often delays audio until volume is applied.
    postYoutube(iframe, { event: "command", func: "unMute", args: "" });
    postYoutube(iframe, { event: "command", func: "setVolume", args: [100] });
    postYoutube(iframe, { event: "command", func: "setVolume", args: [100] });
  };

  const postVimeo = (iframe, payload) => {
    if (!iframe?.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify(payload), "*");
  };

  const vimeoSetMuted = (iframe, muted) => {
    if (!iframe?.contentWindow) return;
    if (muted) {
      postVimeo(iframe, { method: "setMuted", value: true });
      return;
    }
    postVimeo(iframe, { method: "setVolume", value: 1 });
    postVimeo(iframe, { method: "setMuted", value: false });
    postVimeo(iframe, { method: "setVolume", value: 1 });
  };

  const initVideoSoundToggles = (root = document) => {
    root.querySelectorAll(".media-banner__video-sound").forEach((btn) => {
      if (btn.dataset.mediaBannerSoundInit === "true") return;
      const media = btn.closest(".media-banner__media");
      if (!media) return;

      const youtube = media.querySelector("iframe.js-youtube");
      const vimeo = media.querySelector("iframe.js-vimeo");
      const video = media.querySelector("video");

      if (!youtube && !vimeo && !video) return;

      btn.dataset.mediaBannerSoundInit = "true";

      const labelMuted = btn.getAttribute("data-label-muted") || "Unmute video";
      const labelUnmuted = btn.getAttribute("data-label-unmuted") || "Mute video";

      const setUnmuted = (unmuted) => {
        btn.setAttribute("aria-pressed", unmuted ? "true" : "false");
        btn.classList.toggle("media-banner__video-sound--unmuted", unmuted);
        btn.setAttribute("aria-label", unmuted ? labelUnmuted : labelMuted);

        if (video) {
          if (unmuted) {
            video.muted = false;
            video.volume = 1;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(() => {});
            }
          } else {
            video.muted = true;
          }
        }
        if (youtube) {
          youtubeSetMuted(youtube, !unmuted);
        }
        if (vimeo) {
          vimeoSetMuted(vimeo, !unmuted);
        }
      };

      btn.addEventListener("click", () => {
        const currentlyUnmuted = btn.getAttribute("aria-pressed") === "true";
        setUnmuted(!currentlyUnmuted);
      });
    });
  };

  const runForAllMediaBanners = (root) => {
    (root || document).querySelectorAll(".media-banner-section").forEach((section) => {
      initAnimation(section);
      initVideoSoundToggles(section);
    });
  };

  runForAllMediaBanners(document);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
    initVideoSoundToggles(event.target);
  });
})();
